import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SELECTBOX = function (state, payload) {
  state.selectBox = payload
}
mutations.SAVEQUESTION = function (state, payload) {
  if (payload[0].length === 0) {
    state.files = {
      m0201_chapter_id: '',
      classUnitId: [],
      files: {}
    }
    state.saveQues = payload[1]
    state.classUnitId = []
    if (payload[2] !== []) {
      payload[2].forEach(el => {
        state.classUnitId.push(el.id)
      })
    }
  } else {
    state.files = payload[0]
    state.saveQues = payload[1]
    state.classUnitId = []
    if (payload[2] !== []) {
      payload[2].forEach(el => {
        state.classUnitId.push(el.id)
      })
    }
  }
}
mutations.DELETE_ANS = function (state, payload) {
  state.ans = payload
}

const state = {
  rows: [],
  row: null,
  classUnitId: [],
  condition: {},
  selectBox: {},
  saveQues: [],
  files: {
    beforeclass_remarks: '',
    afterclass_remarks: '',
    files: {}
  },
  ans: []
}
const actions = {
  init: ({ commit, state }) => {
    console.debug('called M0201Chapter init')
    return client.postData({ data: { init: { api: 'M0201ChapterService.getChapterFilterSelection' } } })
      .then((data) => {
        commit('SELECTBOX', data.init.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0201Chapter cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0201Chapter search')
    return client.postData({ data: { search: { api: 'M0201ChapterService.searchDetail', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0201Chapter add')
    commit('EDIT',
      {
        id: null
        /* files: {},
        relates: {},
        belongs: {} */
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0201Chapter edit')
    return client.postData({ data: { find: { api: 'M0201ChapterService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0201Chapter delete')
    return client.postData({ data: { delete: { api: 'M0201ChapterService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0201Chapter save')
    return client.postData({ data: { save: { api: 'M0201ChapterService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  saveFile: ({ commit, state }, row) => {
    console.debug('called M0201Chapter save')
    return client.postData({ data: { save: { api: 'M0201ChapterService.saveNewFile', input: row } } })
      .then((data) => {
        commit('SAVEQUESTION', data.save.output)
      })
  },
  saveQuestion: ({ commit, state }, row) => {
    console.debug('called M0201Chapter save')
    return client.postData({ data: { save: { api: 'M0406ClassUnitQuestionService.saveQuestion', input: row } } })
      .then((data) => {
        alert('問題已儲存！')
        commit('SAVEQUESTION', data.save.output)
      })
  },
  searchQuestion: ({ commit, state }, data) => {
    console.debug('called M0201Chapter search')
    return client.postData({ data: { search: { api: 'M0406ClassUnitQuestionService.getClassUnitNotPassed', input: data } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('SAVEQUESTION', data.search.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0201Chapter download')
    return client.download({ data: { download: { api: 'M0201ChapterService.downloadData', input: condition } } })
  },
  deleteAns: ({ commit, state }, row) => {
    console.debug('called M0404ClassUnit delete')
    return client.postData({ data: { delete: { api: 'M0204AnswerService.deleteDataDetails', input: row } } })
      .then((data) => {
        alert('問題已更新！')
        commit('DELETE_ANS', null)
      })
  },
  deleteQues: ({ commit, state }, row) => {
    console.debug('called M0404ClassUnit delete')
    return client.postData({ data: { delete: { api: 'M0406ClassUnitQuestionService.deleteQuestion', input: row } } })
      .then((data) => {
        commit('SAVEQUESTION', data.delete.output)
      })
  },
  deleteFile: ({ commit, state }, row) => {
    console.debug('called M0404ClassUnit delete')
    return client.postData({ data: { delete: { api: 'M0201ChapterService.deleteNewFile', input: row } } })
      .then((data) => {
        commit('SAVEQUESTION', data.delete.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0201Chapters/M0201ChaptersStore.js